<template>
  <v-autocomplete
    :items="items"
    item-text="descricao"
    item-value="valor"
    v-bind="$attrs"
    v-bind:value="modelValue"
    v-on="inputListeners"
  >
    <template #progress>
      <v-progress-linear
        style="position: absolute"
        height="2px"
        color="red"
        indeterminate
      ></v-progress-linear>
    </template>

    <template #prepend-item>
      <v-list-item
        v-if="modelValue.length === items.length"
        class="py-2"
        @click="updateModel([])"
      >
        <v-icon class="ml-2" color="primary">mdi-checkbox-marked</v-icon>
        <span class="ml-2 font-weight-medium">Desmarcar Todos</span>
      </v-list-item>

      <v-list-item
        v-else
        class="py-2"
        @click="updateModel(Helpers.arrayColumn(items, 'valor'))"
      >
        <v-icon v-if="modelValue.length > 0" class="ml-2" color="primary">mdi-minus-box</v-icon>
        <v-icon v-else class="ml-2">mdi-checkbox-blank-outline</v-icon>
        <span class="ml-2 font-weight-medium">Selecionar Todos</span>
      </v-list-item>

      <v-divider />
    </template>

    <template #selection="{item}">
      <template v-if="modelValue.indexOf(item.valor) < qtdeVisivelSelecionados">
        <span>{{item.descricao}}</span><template v-if="apendarVirgula(item)">,&nbsp;</template>
      </template>

      <template v-if="modelValue.indexOf(item.valor) === qtdeVisivelSelecionados">
        <span class="ml-1 text-grat-900">(+ {{modelValue.length - qtdeVisivelSelecionados}})</span>
      </template>
    </template>

    <template #prepend-inner>
      <slot name="prepend-inner" />
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: "FiltrosAutocomplete",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: Array,
      required: true
    },
    qtdeVisivelSelecionados: {
      type: [Number],
      default: 4
    },
    items: Array
  },
  computed: {
    inputListeners: function () {
      const vm = this

      return Object.assign({},
        vm.$listeners, {
          input: function (values) {
            if ([null, undefined].includes(values)) {
              values = vm.$attrs.multiple ? [] : '';
            }

            vm.updateModel(values)
          }
        }
      )
    }
  },
  methods: {
    updateModel(values) {
      const valuesValidos = values ? values : []
      this.$emit('update:modelValue', valuesValidos)
    },
    apendarVirgula (item) {
      const indexOf = this.modelValue.indexOf(item.valor)
      return indexOf !== this.modelValue.length - 1 && indexOf < (this.qtdeVisivelSelecionados - 1)
    }
  }
}
</script>

<style scoped>
.pl-14px {
  padding-left: 14px
}
.text-grat-900 {
  color: #999;
}
</style>
